import { AxiosResponse } from "axios";
import type {
  SurveySubmissionData,
  SurveySubmissionDelta,
} from "@coolset/data-room";
import { Preview } from "modules/Preview/preview";
import { ApiBaseUrl, request } from "shared/clients/baseClient";
import {
  camelizeObject,
  camelizeObjectWithExclusions,
} from "shared/helpers/object";

const createPreviewSession = (
  surveyId: number | string,
): Promise<Preview.CreateSessionResponse> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${surveyId}/preview/`,
      method: "POST",
    },
  }).then((res: AxiosResponse) =>
    camelizeObject<Preview.CreateSessionResponse>(res.data),
  );
};

const getPreviewSubmission = (
  compoundId: string,
): Promise<SurveySubmissionData> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/preview/submission/${compoundId}/`,
      method: "GET",
    },
  }).then(
    (res: AxiosResponse) =>
      camelizeObjectWithExclusions(res.data, [
        "answer_data",
      ]) as SurveySubmissionData,
  );
};

const postPreviewAnswer = ({
  submissionId,
  fieldId,
  context,
  value,
}: Preview.AnswerParams): Promise<Partial<SurveySubmissionDelta>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/preview/submission/${submissionId}/answer/`,
      method: "POST",
      // Built by hand: context keys are survey context-object names and
      // must not be re-cased by snakizeObject.
      data: { field_id: fieldId, context, value },
    },
  }).then(
    (res: AxiosResponse) =>
      camelizeObjectWithExclusions(res.data, [
        "answer_data",
      ]) as Partial<SurveySubmissionDelta>,
  );
};

export const previewClient = {
  createPreviewSession,
  getPreviewSubmission,
  postPreviewAnswer,
};
